// extracted by mini-css-extract-plugin
export default {"join_our_service":"JoinOurService_join_our_service__TrGkp","btn":"JoinOurService_btn__gObxU"};